import { useClassNames } from "@/utils/classNames";

import { Icon } from "../Icon";
import { IconButtonProps } from "./types";
import styles from "./IconButton.module.scss";

/**
 * IconButton component for displaying icon-only buttons
 * Commonly used in video player controls and navigation
 *
 * @param props - The button properties
 * @returns the icon button component
 */
const IconButton = ({
  icon,
  onClick,
  ariaLabel,
  disabled = false,
  className,
}: IconButtonProps) => {
  const cn = useClassNames(styles, styles["icon-button"], className);

  return (
    <button
      className={cn}
      onClick={onClick}
      aria-label={ariaLabel}
      disabled={disabled}
      type="button"
    >
      <Icon className={styles.icon} icon={icon} />
    </button>
  );
};

export { IconButton };
